import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('appointment-form', 'organizations-req', [
  'FETCH_BY_USER_ID',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'organizations',
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/organizations-req.js